import {
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Stack,
  FormControl,
  Select,
  Checkbox,
} from "@chakra-ui/react";
import Input from "components/Input/Input";
import Button from "components/Button/Button";
import { useState, useEffect, useCallback } from "react";
import { useGetSavedBanksQuery } from "services/p2pApi";
import { getBankLabel } from "./AddPaymentDetails";

const AddPaymentMethod = ({ isOpen, onClose, state, setState }) => {
  const [method, setMethod] = useState(null);
  const [fetchState, setFetchState] = useState("");

  const {data: savedBanks, isLoading: isLoadingSavedBanks} = useGetSavedBanksQuery(undefined, {skip: fetchState !== "fetchingSavedBanks"})

  const [innerState, setInnerState] = useState({});

  const handleInnerState = (state) => {
    setInnerState({ ...innerState, ...state });
  };

  const resetInnerState = () => {
    setMethod(null);
    setInnerState({});
  };

  const addBankTransferMethod = (method) => {
    if (state.type === "buy" && innerState)
      return {
        method,
        payingToLabel: innerState?.bankName ?? "Bank Transfer",
      };
    if (state.type === "sell" && innerState)
      return {
        method,
        receivingIntoLabel: innerState?.bankName,
        receivingIntoAddress: innerState?.bankAccountNumber,
        accountName: innerState?.bankAccountName,
        saveRecord: innerState?.saveRecord,
      };
  };

  const addChangeraMethod = (method) => ({
    method,
    receivingIntoLabel: "changera",
    receivingIntoAddress: innerState?.changeraId,
  });

  const methodSwitch = (method) => {
    const switcher = {
      bitmamaWallet: () =>
        setState({
          useInternalWallet: true,
          methods: [...state.methods, method],
        }),
      bankTransfer: () =>
        setState({
          methods: [...state.methods, method],
          paymentOption: [
            ...state?.paymentOption,
            addBankTransferMethod(method),
          ],
        }),
      changeraId: () =>
        setState({
          methods: [...state.methods, method],
          paymentOption: [...state?.paymentOption, addChangeraMethod(method)],
        }),
    };

    return switcher[method];
  };

  const handleSelectedBank = (e) => {
    const bank = savedBanks?.banks?.find((m) => String(m._id) === String(e));
    handleInnerState({ 
      bankAccountName: bank?.bankAccountName, 
      bankName: bank?.bankName, 
      bankAccountNumber: bank?.bankAccountNumber,
      saveRecord: false,
    })
    setMethod("bankTransfer")
  };

  // console.log("INNER STATE", innerState);
  const handleAdd = () => {
    const m = state?.methods.includes(method);
    if (!m) {
      methodSwitch(method) && methodSwitch(method)();
      resetInnerState();
      onClose();
    }
  };

  let paymentMethodsMap = [
    { key: "bankTransfer", name: "Bank Transfer", color: "#F4B740" },
    { key: "chooseBank", name: "Select from saved accounts", color: "#F4B740" },
    // { key: "changeraId", name: "Changera", color: "#3B5C9D" },
    { key: "bitmamaWallet", name: "Bitmama Wallet", color: "#04822D" },
  ];

  if(state.type === "buy") {
    paymentMethodsMap = paymentMethodsMap.filter((pm) => pm.key !== "chooseBank")
  }

  const availableMethods = () =>
    paymentMethodsMap.filter((m) => !state?.methods?.includes(m.key));

  const isAddDisabled = () => {
    if (method === "bankTransfer" && state.type === "sell")
      return !(
        innerState?.bankAccountName &&
        innerState?.bankName &&
        innerState?.bankAccountNumber
      );
    return false;
  };


  const fetchSavedBanks = useCallback(() => {
    const prevFetchState = fetchState;
    try {
      if(isLoadingSavedBanks) {
        setFetchState("");
      } else if(!savedBanks) {
        setFetchState("fetchingSavedBanks");
      } else {
        setFetchState("")
      }
    } catch(err) {
      setFetchState(prevFetchState);
    }
  }, [isLoadingSavedBanks, fetchState, savedBanks]);

  useEffect(() => {
    if(method === "chooseBank") {
      if(!savedBanks?.banks && fetchState !== "fetchingSavedBanks") {
        fetchSavedBanks();
      }
    } 
  }, [method, fetchState, fetchSavedBanks, savedBanks?.banks])

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent bg="#F8F9FD" overflow="hidden" borderRadius="16px">
        <ModalHeader p="26px 0" textAlign="center" bg="white" fontSize="md">
          Add payment method
        </ModalHeader>
        {/* <ModalCloseButton /> */}
        <ModalBody p="24px 48px">
          <Stack gridGap="16px">
            <FormControl flex="1">
              <Box
                mb="8px"
                as="label"
                d="inline-block"
                fontSize="md"
                color="#4E4B66"
              >
                Select Payment Method
              </Box>
              <Select
                variant="filled"
                h="56px"
                bg="#EFF0F7"
                borderRadius="16px"
                _focus={{
                  borderColor: "#06C344",
                  boxShadow: "0 0 0 3px #06C3448f",
                }}
                value={method ?? ""}
                onChange={(e) => setMethod(e.target.value)}
                placeholder="Choose Method"
              >
                {/* <option value="changeraId">Changera</option> */}
                {/* <option value="bitmamaWallet">Bitmama Wallet</option> */}

                {availableMethods()?.map((method) =>
                  state?.methods?.length > 0 &&
                  !state?.methods?.includes("bitmamaWallet") ? (
                    <option key={method.key} value={method.key}>
                      {method.name}
                    </option>
                  ) : (
                    <option key={method.key} value={method.key}>
                      {method.name}
                    </option>
                  )
                )}
              </Select>
            </FormControl>

            {method === "chooseBank" && (
              <FormControl flex="1">

                <Select
                  variant="filled"
                  h="56px"
                  bg="#EFF0F7"
                  borderRadius="16px"
                  _focus={{
                    borderColor: "#06C344",
                    boxShadow: "0 0 0 3px #06C3448f",
                  }}
                  value={method ?? ""}
                  onChange={(e) => handleSelectedBank(e.target.value)}
                  placeholder="Select an account"
                >
                  {/* <option value="changeraId">Changera</option> */}
                  {/* <option value="bitmamaWallet">Bitmama Wallet</option> */}

                  {Array.isArray(savedBanks?.banks) && savedBanks?.banks?.map((bank) => (
                    <option key={bank._id} value={bank._id}>
                      {getBankLabel(bank)}
                    </option>
                  ))}
                </Select>
              </FormControl>
            )}

            {method === "changeraId" && (
              <FormControl flex=".5">
                <Box
                  mb="8px"
                  as="label"
                  d="inline-block"
                  fontSize="md"
                  color="#4E4B66"
                >
                  Changera ID
                </Box>

                <Input
                  value={innerState?.changeraId ?? ""}
                  onChange={(e) =>
                    handleInnerState({ changeraId: e.target.value })
                  }
                  w="100%"
                  placeholder="Enter your id"
                />
              </FormControl>
            )}

            {method === "bankTransfer" && (
              <Stack gridGap="16px">
                {state.type !== "buy" && (
                  <FormControl flex="1">
                    <Box
                      mb="8px"
                      as="label"
                      d="inline-block"
                      fontSize="md"
                      color="#4E4B66"
                    >
                      Account Name
                    </Box>
                    <Input
                      value={innerState?.bankAccountName ?? ""}
                      onChange={(e) =>
                        handleInnerState({ bankAccountName: e.target.value })
                      }
                      w="100%"
                      placeholder="Enter account name"
                    />
                  </FormControl>
                )}
                {state.type !== "buy" && (
                  <FormControl flex="1">
                    <Box
                      mb="8px"
                      as="label"
                      d="inline-block"
                      fontSize="md"
                      color="#4E4B66"
                    >
                      Bank Name
                    </Box>
                    <Input
                      value={innerState?.bankName ?? ""}
                      onChange={(e) =>
                        handleInnerState({ bankName: e.target.value })
                      }
                      w="100%"
                      placeholder="Enter bank name"
                    />
                  </FormControl>
                )}
                {state.type !== "buy" && (
                  <FormControl flex="1">
                    <Box
                      mb="8px"
                      as="label"
                      d="inline-block"
                      fontSize="md"
                      color="#4E4B66"
                    >
                      Account No
                    </Box>
                    <Input
                      value={innerState?.bankAccountNumber ?? ""}
                      onChange={(e) =>
                        handleInnerState({ bankAccountNumber: e.target.value })
                      }
                      w="100%"
                      placeholder="Enter account no."
                    />
                  </FormControl>
                )}
              </Stack>
            )}

            {method === "bankTransfer" && state.type !== "buy" && (
              <FormControl>
                <Checkbox
                  _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                  isChecked={innerState?.saveRecord ?? false}
                  onChange={(e) =>
                    handleInnerState({ saveRecord: e.target.checked })
                  }
                  colorScheme="green"
                  defaultIsChecked
                >
                  Save Record
                </Checkbox>
              </FormControl>
            )}
          </Stack>
        </ModalBody>

        <ModalFooter justifyContent="center" pb="30px" gridGap="14px">
          <Button
            onClick={onClose}
            bg="transparent"
            border="2px solid #03A438"
            color="#03A438"
          >
            Cancel
          </Button>
          <Button disabled={isAddDisabled()} onClick={handleAdd}>
            Add
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddPaymentMethod;
